import { z } from 'zod';

export const ApplicationMethodSchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    method: z.string().optional(),
    address: z.string().optional(),
    information: z.string().optional(),
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateApplicationMethodSchema = ApplicationMethodSchema.omit({ id: true });
export const UpdateApplicationMethodSchema = ApplicationMethodSchema;